<template>
  <div class="date-range-picker">
    
    <input
      :id="inputId"
      ref="dateInput"
      class="default-input-klass"
      :value="displayValue"
      :placeholder="placeholder"
      type="text"
      readonly
    />
    <div :id="calendarId"></div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, onBeforeUnmount } from 'vue';

export default defineComponent({
  name: 'DateRangePicker',
  
  props: {
    modelValue: {
      type: Object,
      default: () => ({start: '',end: ''})
    },
    inputId: {
      type: String,
      default: 'calendar-input'
    },
    calendarId: {
      type: String,
      default: 'calendar-container'
    },
    placeholder: {
      type: String,
      default: 'Select date range'
    }
  },
  
  emits: ['update:modelValue', 'visibility-change'],
  
  setup(props, { emit }) {
    const dateInput = ref(null);
    let calendarInstance = null;

    const displayValue = computed(() =>
      props.modelValue.start && props.modelValue.end
        ? `${props.modelValue.start} ~ ${props.modelValue.end}`
        : ''
    );

    const handleRangeConfirm = (selectedRange) => {
      emit('update:modelValue', selectedRange);
      emit('visibility-change', false);
    };

    const hide = () => {
      if (calendarInstance) {
        calendarInstance.hide();
        emit('visibility-change', false);
      }
    };

    const show = () => {
      if (calendarInstance) {
        calendarInstance.show();
        emit('visibility-change', true);
      }
    };

    const initCalendar = () => {
      if (!dateInput.value) return;

      calendarInstance = window.initVanillaCalendar(
        dateInput.value, 
        props.calendarId, 
        displayValue.value,
        handleRangeConfirm
      );

      dateInput.value.addEventListener('click', () => {
        show();
      });
    };
    
    onMounted(() => {
      initCalendar();
    });
    
    onBeforeUnmount(() => {
      if (calendarInstance) {
        calendarInstance.destroy();
        calendarInstance = null;
      }
      if (dateInput.value) {
        dateInput.value.removeEventListener('click', show);
      }
    });

    return {
      dateInput,
      displayValue,
      hide,
      show
    };
  }
});
</script>
